import type { SvgComponent } from '@/types/SvgComponent';

export const AllViewModeIcon: SvgComponent = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M8.66667 4H4.66667C4.29848 4 4 4.29848 4 4.66667V8.66667C4 9.03486 4.29848 9.33333 4.66667 9.33333H8.66667C9.03486 9.33333 9.33333 9.03486 9.33333 8.66667V4.66667C9.33333 4.29848 9.03486 4 8.66667 4Z"
        stroke="white"
        strokeWidth="0.803556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 4H12.6667C12.2985 4 12 4.29848 12 4.66667V8.66667C12 9.03486 12.2985 9.33333 12.6667 9.33333H16.6667C17.0349 9.33333 17.3333 9.03486 17.3333 8.66667V4.66667C17.3333 4.29848 17.0349 4 16.6667 4Z"
        stroke="white"
        strokeWidth="0.803556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.66667 12H4.66667C4.29848 12 4 12.2985 4 12.6667V16.6667C4 17.0349 4.29848 17.3333 4.66667 17.3333H8.66667C9.03486 17.3333 9.33333 17.0349 9.33333 16.6667V12.6667C9.33333 12.2985 9.03486 12 8.66667 12Z"
        stroke="white"
        strokeWidth="0.803556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6667 12H12.6667C12.2985 12 12 12.2985 12 12.6667V16.6667C12 17.0349 12.2985 17.3333 12.6667 17.3333H16.6667C17.0349 17.3333 17.3333 17.0349 17.3333 16.6667V12.6667C17.3333 12.2985 17.0349 12 16.6667 12Z"
        stroke="white"
        strokeWidth="0.803556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
